// require all images to include in manifest.json
(require as any).context('~/ui/images', true);

import widgetFactory from '~/ui/react/elementFactory';
import locator from '~/services/locator';
import state from '~/state';

// global styles
import '~/ui/styles';

// elements
import UiMessages from '~/ui/react/ui-elements/UiMessages';
import Picture from '~/ui/react/ui-elements/Picture';
import ScrollToTarget from '~/ui/react/ui-elements/ScrollToTarget';

const DOC = document;

/**
 * Set Webpack public path from environment
 */
// @ts-ignore
__webpack_public_path__ = locator.config.getEnv('runtime.assetsBase');

/**
 * Mount elements
 */
const elementRenderer = locator.elementRenderer;
const rendererContainer = elementRenderer.getContainer();

rendererContainer.registerBulk({
    // UiMessages,
    Picture,
    ScrollToTarget,
});

// wrap elements with common components
rendererContainer.factory.useElementFactory(widgetFactory);

// mount and finish bootstrapping
elementRenderer.mount(DOC.body, () => {
    DOC.documentElement.classList.remove('no-js');
});

// set global api error handler
locator.apiService.addErrorListener((error, errorType) => {
    const t = locator.translator.get;

    const typeInfo = 'info';
    const refreshMessage = '. ' + t('api.message.please_refresh');
    let message: string | null = t('api.error') + refreshMessage;
    let type: string = 'error';

    if (errorType === 'response') {
        switch (error.response?.status) {
            case (404):
                message = t('api.error.404') + refreshMessage;
                type = typeInfo;
                break;
            case (503):
                message = t('api.error.503');
                type = typeInfo;
                break;
        }
    } else if (errorType === 'request') {
        message = t('api.error.network');
        type = typeInfo;
    }

    state.ui.setMessage(message as string, type as any);
});
